import { useEffect, useState,useContext } from "react";
import { toast } from "react-toastify";
import { createDocumentsType, updateDocumentsType } from "../../../Utility/Api";
import { WarehouseContext } from '../../../Utility/UserContext';



export const EditDocumentType = ({ showModal, setShowModal, fetchDocumentType, selectedDocumentType, fetchdata, AddorEdit }) => {

    const { showLoader, hideLoader,UserItem,shopItem } = useContext(WarehouseContext);

    const [formData, setFormData] = useState({
        title: '',
        status: ''
    });
    const [errors, setErrors] = useState({});


    useEffect(() => {


        setFormData({
            ...formData,
            title: selectedDocumentType?.title,
            status: selectedDocumentType?.status?.toString() || ''
        });
    }, [selectedDocumentType])

    const handleSubmit = async (e) => {
        e.preventDefault();
        showLoader()
        const validationErrors = {};

        if (!formData.title) {
            validationErrors.title = "Documents Type  is required.";
            // toast.error("Documents Type is required.");
        }
        //     if (!formData.status) {
        //     validationErrors.status = "Status is required.";
        //     // toast.error("Status is required."); // Toast for missing status
        // }


        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            hideLoader()
            return;
        }

        const payload = {
            title: formData.title,
            status: !selectedDocumentType ? '1' : formData.status,
            shop_id:shopItem?.shop_id,
            created_by:UserItem?.user_id,
        };

        console.log('Payload being sent:', payload);
        try {
            if (AddorEdit) {
                await createDocumentsType(payload);
                hideLoader()
                toast.success('Documents Type Added successfully');
            } else {
                await updateDocumentsType(selectedDocumentType?.id, payload);
                hideLoader()
                toast.success('Documents Type Updated successfully');
            }
            setShowModal(false);
            fetchDocumentType();
            fetchdata();
        } catch (error) {
            console.error('Error Documents Type data:', error);
            hideLoader()
            // toast.error('Error Category Quantity');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };
    const handleclear = () => {
        setShowModal(false);
        setErrors({
            category: ""
        })
        setFormData({
            category: "",
        });
    };


    return (
        <>
            {showModal && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header border-0">
                                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>{selectedDocumentType ? 'Edit Documents Type' : 'Add Documents Type'}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => handleclear()}
                                ></button>
                            </div>
                            <div className="modal-body" style={{ fontFamily: "poppins" }}>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group mb-3 d-flex align-items-center">
                                        <label className="col-3 text-normal">Documents Type</label>
                                        <div className="col-8">
                                            <input
                                                type="text"
                                                name="title"
                                                value={formData.title}
                                                onChange={handleChange}
                                                className="form-control text-normal"

                                            />
                                            {errors.title && (
                                                <small className="text-danger">{errors.title}</small>
                                            )}
                                        </div>
                                    </div>
                                    {selectedDocumentType &&
                                        <div className="form-group mb-3">
                                            <label>Status</label>
                                            <select
                                                name="status"
                                                value={formData.status}
                                                onChange={handleChange}
                                                className="form-control"

                                            >
                                                <option value="" disabled selected>Select Status</option>
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </select>
                                        </div>
                                    }
                                    <div className="mt-5">
                                        <button type="submit" className="btn btn-success float-end text-normal rounded-1">
                                            {selectedDocumentType ? 'Update Documents Type' : 'Add Documents Type'}</button>
                                        &nbsp;
                                        <button
                                            type="button"
                                            className="btn btn-secondary ml-2 float-end me-1 text-normal rounded-1"
                                            onClick={() => handleclear()}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}</>
    )
}